import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Dialog } from 'react-toolbox';
import { connect } from 'react-redux';
import Loading from 'components/Loading';
import ColoredButton from 'components/ColoredButton';
import { getEstimatorsForZipCode } from 'actionCreators/estimators';
import styles from './styles';

class EstimatorListModal extends React.Component {
  state = { loading: true };

  componentDidMount = () => this.props.getEstimatorsForZipCode(this.props.zipCode)
    .finally(() => this.setState({ loading: false }));

  handleNavigate = (id) => {
    this.props.dismiss();
    window.open(`${window.location.origin}/estimators/${id}`, '_blank', 'noopener,noreferrer');
  };

  render = () => {
    const { show, dismiss, zipCode, sharedEstimators, estimator } = this.props;
    const { loading } = this.state;
    const filteredSharedEstimator = sharedEstimators.filter(est => est.id !== estimator.id);
    return (<Dialog
      active={show}
      onEscKeyDown={dismiss}
      onOverlayClick={dismiss}
      title={`List of Estimators who share Zip code: ${zipCode}`}
    >
      {loading ? (<Loading />) : (<Fragment>
        {filteredSharedEstimator.map(est => <div key={est.id}>
          <button
            key={est.id}
            className={styles.zipBtn}
            type="button" onClick={() => this.handleNavigate(est.id)}
          >{est.name}</button>
        </div>)}
        <ColoredButton responsive color="green" label="OK" onClick={dismiss} />
      </Fragment>)}
    </Dialog>);
  };
}

EstimatorListModal.propTypes = {
  zipCode: PropTypes.string.isRequired,
  estimator: PropTypes.object,
  getEstimatorsForZipCode: PropTypes.func,
  show: PropTypes.bool,
  sharedEstimators: PropTypes.array,
  dismiss: PropTypes.func,
  error: PropTypes.string,
};

const mapStateToProps = state =>
  ({ sharedEstimators: state.estimators.forZipCode.data || [] });

export default connect(mapStateToProps, { getEstimatorsForZipCode })(EstimatorListModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/estimators/components/estimatorListModal.jsx